export const NOTES_ONBOARDING_SPOTLIGHT = {
	SPOTLIGHT_DISMISSED: 'notes-onboarding:hasSpotlightDismissed',
} as const;

export const NotesOnboardingSpotlightKeys = [...Object.values(NOTES_ONBOARDING_SPOTLIGHT)] as const;
